import { addPlayIcon } from '../components/play-icon';
import { addControls } from '../components/controls';

export const createMarkup = ($video, index) => {
  $video.classList.add('c-video');
  addPlayIcon($video);
  addControls($video, index);
};
